// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {FormFactorChangeListener, sharedFormFactorChangeListener, createExpandableMediaQueryStylesheet} from '../core/Metrics';
import CoreStyles from '../core/Styles';
import {TitleText, BodyText} from '../core/Type';
import {FixedSpace} from '../core/Spacing';
// Controls
import TabBar from '../controls/TabBar';
// Layouts
import {Grid, GridRow, GridColumn, DockedTOCandContentLayout} from '../layouts/Grid';
import {CssGrid, CssGridRow, CssGridColumn, CssGridSpace} from '../layouts/CssGrid';
import MainAndSidebarLayout from '../layouts/MainAndSidebarLayout';
import ToolBar from '../layouts/ToolBar';
// Modules
import SiteBar from '../modules/SiteBar';
import LessonTOC from '../modules/LessonTOC';
import ShareBar from '../modules/ShareBar';
import SiteFooter from '../modules/SiteFooter';
// Images
import videoImage1 from './images/video-image-1.png';


export default class VideoPage extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            page: {
                display: "flex",
                flexDirection: "column-reverse",
            },
        });
        let page = null;
        const sidebarBehavior = sharedFormFactorChangeListener.getSidebarBehavior();
        if (sidebarBehavior === FormFactorChangeListener.SidebarBehavior.Docked) {
            page = (
                <div className={css(styles.page)}>
                    <DockedTOCandContentLayout toc={(
                        <LessonTOC variant={LessonTOC.Variant.Docked} />
                    )} content={(
                        <div>
                            <VideoPlayer />
                            <Grid>
                                <GridRow>
                                    <GridColumn variant={GridColumn.Variant.OneSixth}></GridColumn>
                                    <GridColumn>
                                        <VideoDetails />
                                    </GridColumn>
                                    <GridColumn variant={GridColumn.Variant.OneSixth}></GridColumn>
                                </GridRow>
                            </Grid>
                            <FixedSpace variant={FixedSpace.Variant.Vertical} size={FixedSpace.Size.XLarge} />
                            <SiteFooter />
                        </div>
                    )} />
                    <SiteBar variant={SiteBar.Variant.Stretched} />
                </div>
            );
        } else {
            const sideSpace = <CssGridSpace
                size={0}
                sizeDesktop={1}
                sizeTablet={2}
            />;

            const mainContent = <GridColumn>
                <VideoPlayer />
                <CssGrid
                    sizeDesktop={9}
                    sizeTablet={12}
                >
                    <CssGridRow>
                        {sideSpace}
                        <CssGridColumn
                            sizeTablet={8}
                            sizeDesktop={7}
                        >
                            <VideoDetails />
                        </CssGridColumn>
                        {sideSpace}
                    </CssGridRow>
                </CssGrid>
            </GridColumn>;

            page = (
                <div className={css(styles.page)}>
                    <SiteFooter />
                    <FixedSpace
                        variant={FixedSpace.Variant.Vertical}
                        size={FixedSpace.Size.XLarge}
                    />
                    <MainAndSidebarLayout
                        sidebarContent={<LessonTOC />}
                        mainContent={mainContent}
                    />
                    <SiteBar />
                </div>
            );
        }
        return page;
    }
}

class VideoPlayer extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                height: 480,
                backgroundColor: CoreMetrics.Color.Neutral.Black,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            },
            video: {
                maxWidth: "100%",
                maxHeight: "100%",
            },
        });
        return (
            <div className={css(styles.container)}>
                <img
                    src={videoImage1}
                    className={css(styles.video)}
                    alt="example video"
                />
            </div>
        );
    }
}

class VideoDetails extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                paddingTop: CoreMetrics.ElementPadding.XLarge(),
            },
            toolbar: {
                paddingLeft: 0,
                paddingRight: 0,
            },
            about: {
                display: "flex",
                flexDirection: "column",
                paddingTop: CoreMetrics.ElementPadding.Medium(),
                paddingBottom: CoreMetrics.ElementPadding.Medium(),
            },
        });
        return (
            <div className={css(styles.container)}>
                <TitleText>Calculating average velocity or speed</TitleText>
                <FixedSpace variant={FixedSpace.Variant.Vertical} />
                <ToolBar styles={[styles.toolbar, CoreStyles.hairlineStrokeBottom]}>
                    <TabBar items={["About", "Transcript"]} selectedIndex={0} />
                </ToolBar>
                <div className={css(styles.about)}>
                    <BodyText>Although speed and velocity are often words used interchangeably, in physics, they are distinct concepts. Speed is calculated by dividing the distance traveled by time. It does not have direction. Average velocity is the displacement (change in position) divided by time.  Created by Sal Khan.</BodyText>
                </div>
                <ShareBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/demo/VideoPage.jsx